import { createContext, useContext } from "react";
import { User } from "firebase/auth";

export interface AuthContextType {
  user: User | null;
  loading: boolean;
  authStatus:
    | "unknown"
    | "allowed"
    | "forbidden"
    | "not_verified"
    | "needs_registration";
  authMe?: {
    uid: string;
    email: string;
    emailVerified: boolean;
    globalRoles: string[];
    orgs: { orgId: string; role: string; status: string }[];
    permissions: string[];
  };
  signInWithEmail: (email: string, password: string) => Promise<void>;
  signInWithGoogle: () => Promise<void>;
  signUpWithEmail: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
  resetPassword: (email: string) => Promise<void>;
  getIdToken: () => Promise<string | null>;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);

export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
